export const CONTACT_SUPPORT = 'Contact Support';
export const PHONE_HELP_DESC = 'Contact us via phone to get help from our support team - 24 X 7.';
export const CLOSE_TEXT = 'Close';
export const CALL_NUM_TEXT = 'Call 855-711-7669';
export const CALL_NUM = '855-711-7669';
export const DATA1 = 'Data may be inaccurate ';
export const DATA2 = 'We are working on it. Please contact support for assistance.';
